import base from '../dr-base'
import drText from './dr-text.vue'

const schema = {
  $Type: 'dr-text',
  name: 'Text',
  group: 'Common widgets',
  icon: 'text',
  ...base,
  properties: {
    ...base.properties,
    Text: {
      name: 'vuetifyWidgets.dr-text.inputText',
      type: 'string',
      default: 'Text',
      component: 'dr-value-editor'
    },
    Mode: {
      name: 'vuetifyWidgets.dr-text.mode',
      type: 'string',
      default: 'text',
      enum: [ {
        value: 'text',
        text: 'vuetifyWidgets.dr-text.text'
      },{
        value: 'paragraph',
        text: 'vuetifyWidgets.dr-text.paragraph'
      },{
        value: 'heading1',
        text: 'vuetifyWidgets.dr-text.heading1'
      },{
        value: 'heading2',
        text: 'vuetifyWidgets.dr-text.heading2'
      },{
        value: 'heading3',
        text: 'vuetifyWidgets.dr-text.heading3'
      },{
        value: 'heading4',
        text: 'vuetifyWidgets.dr-text.heading4'
      },{
        value: 'heading5',
        text: 'vuetifyWidgets.dr-text.heading5'
      },{
        value: 'heading6',
        text: 'vuetifyWidgets.dr-text.heading6'
      }]
    }
  }
}

export default {
  schema,
  component: drText
}